"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.responseSuccessInterceptor = void 0;
const responseSuccessInterceptor = (response) => {
    return response.data;
};
exports.responseSuccessInterceptor = responseSuccessInterceptor;
